import { Reveal } from "./Reveal";

export function SectionHeading({ eyebrow, title, text, align = "left", insignia }) {
  return (
    <Reveal className={`section-heading section-heading-${align}`}>
      <p className="eyebrow" data-testid={`${eyebrow.toLowerCase().replaceAll(" ", "-")}-eyebrow`}>
        {eyebrow}
      </p>
      {insignia ? (
        <img loading="lazy" className="section-heading-insignia" src={insignia.src} alt={insignia.alt} data-testid={insignia.testid} />
      ) : null}
      <h2>{title}</h2>
      {text ? <p className="section-copy">{text}</p> : null}
    </Reveal>
  );
}
